<template>
  <img :src="iconSrc" :style="style" />
</template>

<script setup>
import { computed, defineProps } from 'vue'

const props = defineProps({
  determination: {
    type: String,
    required: true,
  },
  size: {
    type: Number,
    default: null,
  },
})

const iconSrc = computed(() =>
  props.determination === 'ir35'
    ? '/gfx/ir35-logo-indigo.svg'
    : '/gfx/worker-classification-logo-indigo.svg',
)

const style = computed(() => {
  if (props.size === null) {
    return {}
  }
  return {
    height: 'auto',
    maxWidth: `${props.size}px`,
  }
})
</script>
